import { render } from "./BackButton.vue?vue&type=template&id=41e3c5d0&scoped=true&lang=pug"
const script = {}

import "./BackButton.vue?vue&type=style&index=0&id=41e3c5d0&scoped=true&lang=sass"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41e3c5d0"]])

export default __exports__